__turbopack_context__.v({
  "centered": "HistoryNavigations-module-scss-module__Br4Sba__centered",
  "chevron": "HistoryNavigations-module-scss-module__Br4Sba__chevron",
  "link": "HistoryNavigations-module-scss-module__Br4Sba__link",
  "linksBox": "HistoryNavigations-module-scss-module__Br4Sba__linksBox",
  "navigations": "HistoryNavigations-module-scss-module__Br4Sba__navigations",
  "navigationsTitle": "HistoryNavigations-module-scss-module__Br4Sba__navigationsTitle",
  "spaceBetween": "HistoryNavigations-module-scss-module__Br4Sba__spaceBetween",
  "wrapper": "HistoryNavigations-module-scss-module__Br4Sba__wrapper",
});
